import useId from '../utils/useId';
import * as React from 'react';
export const warpSvg = React.forwardRef(function warpSvgInner(props, ref) {
  const id_0 = useId();
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#242424',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement(
      'mask',
      {
        id: `bi_warp__a_${id_0}`,
        style: {
          maskType: 'luminance',
        },
        maskUnits: 'userSpaceOnUse',
        x: 5,
        y: 5,
        width: 22,
        height: 22,
      },
      /*#__PURE__*/ React.createElement('path', {
        d: 'M26.234 5.775H5.76v20.474h20.474V5.775Z',
        fill: '#fff',
      }),
    ),
    /*#__PURE__*/ React.createElement(
      'g',
      {
        mask: `url(#bi_warp__a_${id_0})`,
        fill: '#fff',
      },
      /*#__PURE__*/ React.createElement('path', {
        d: 'M25.758 12.934a10.257 10.257 0 0 0-6.85-6.737c1.25 4.02 4.208 6.466 6.85 6.737Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M25.984 13.776a16.662 16.662 0 0 0-.036-.155c-3.995-.126-8.007-2.767-9.095-7.81a10.282 10.282 0 0 0-2.924.171c1.577 4.913 7.202 7.697 12.055 7.794Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M26.124 14.547c-6.944-.04-12.794-3.537-14.605-7.745a10.264 10.264 0 0 0-3.117 2.341c3.89 3.37 10.72 5.537 17.744 5.557l-.022-.153Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M26.215 15.472c-5.957-.003-14.279-.904-19.436-3.927a10.17 10.17 0 0 0-.903 2.887c5.68 1.046 13.23 1.18 20.344 1.18l-.006-.14Zm-7.302 10.354a10.26 10.26 0 0 0 6.84-6.72c-2.637.273-5.588 2.711-6.84 6.72Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'm25.944 18.418.036-.155c-4.847.098-10.464 2.876-12.046 7.778a10.28 10.28 0 0 0 2.923.17c1.092-5.031 5.098-7.667 9.087-7.793Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'm26.122 17.493.022-.154c-7.019.02-13.844 2.186-17.734 5.55.875.964 1.931 1.76 3.115 2.336 1.817-4.202 7.661-7.692 14.598-7.732Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M26.22 16.428c-7.112 0-14.66.133-20.341 1.18.16 1.018.469 1.987.905 2.883 5.158-3.02 13.474-3.92 19.43-3.923l.006-.14Z',
      }),
    ),
  );
});
warpSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var warp = {
  category: 'brand',
  colorable: false,
  name: 'warp',
  svg: warpSvg,
};
